import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/api/user/login',
    method: 'post',
    data: {
      ...data,
      clientType: 'admin'
    }
  })
}

export function logout() {
  return request({
    url: '/api/user/logout',
    method: 'post',
    data: {
      clientType: 'admin'
    }
    // Refresh Token 會自動通過 Cookie 傳遞，不需要在請求中傳遞
  })
}

export function getInfo() {
  return request({
    url: '/api/user/info',
    method: 'get'
  })
}

export function updatePassword(data) {
  return request({
    url: '/api/user/password',
    method: 'put',
    data: {
      ...data,
      clientType: 'admin'
    }
  })
}
